export const hasRole = (role, tenant, profile) =>
  profile?.isLoaded && profile.roles && profile.roles[tenant] === role

export const isAdmin = (tenant, profile) => hasRole('admin', tenant, profile)



// WEBPACK FOOTER //
// ./src/helpers/auth.ts